import React from "react";
import {FormPageLayout} from "../../components/layout/FormPageLayout";
import {ApplicationListFeature} from "../../features/applicationList";

const ApplicationListPage = () => (
  <FormPageLayout
    body={
      <ApplicationListFeature />
    }
  />
);

export default ApplicationListPage;
